export enum Step {
  Init = 0,
  Form = 1,
  Verify = 2,
}
